import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import firebaseMessaging from './firebase'
import { Chart } from 'chart.js'
import Chartkick from 'vue-chartkick'
import { transliterate } from "./transliterate";
Vue.use(Chartkick.use(Chart));

Vue.filter('transliterate', function (text, languageCode) {
  if (!text) return ''
  text = text.toString()
  return transliterate(text, languageCode);
})


Vue.prototype.$messaging = firebaseMessaging
Vue.config.productionTip = false;
Vue.component('vue-phone-number-input', VuePhoneNumberInput);

try {
  firebaseMessaging.onMessage(function (payload) {
    console.log(payload);
    const notificationTitle = payload.notification.title;
    const notificationOptions = {
      body: payload.notification.body,
      icon: payload.notification.icon,
    };

    if (!("Notification" in window)) {
      console.log("This browser does not support system notifications");
    }
    // Let's check whether notification permissions have already been granted
    else if (Notification.permission === "granted") {
      // If it's okay let's create a notification
      var notification = new Notification(notificationTitle, notificationOptions);
      notification.onclick = function (event) {
        event.preventDefault();
        window.focus();
        window.location.href = '/#/MatchPagePar/' + payload.data.matchId;
        notification.close();
      }
    }
  });

} catch (error) {
  console.log(error)
}


new Vue({
  store,
  router,
  i18n,
  VuePhoneNumberInput,
  render: h => h(App)
}).$mount('#app')
